import { dochubInstance } from '../instance';

export type ISendData = {
  exchangeToken: string;
};

export type TPostExchangeToken = {
  bearerToken: string;
};

export default {
  exchangeToken: (data: ISendData): Promise<TPostExchangeToken> =>
    dochubInstance.post('v2/users/auth/exchange-token', data),
};
